export default "__VITE_ASSET__BUfWLJbW__"